import(/* webpackMode: "eager" */ "/home/runner/work/scoville-realtime-interpretation-livekit/scoville-realtime-interpretation-livekit/web/app/global-error.tsx");
